class Notification {
  constructor(el, options = {}) {
    this.el = el;
    this.options = options;
    const closeButton = this.el.querySelector('.js-close');
    closeButton.addEventListener('click', () => this.hide());
  }

  show() {
    if (this.el) {
      this.el.classList.remove(
        'translate-y-2',
        'opacity-0',
        'invisible',
        'sm:translate-y-0',
        'sm:translate-x-2',
        'invisible'
      );
      this.el.classList.add(
        'translate-y-0',
        'opacity-100',
        'sm:translate-x-0',
        'visible'
      );
      if (this.options.hideAfter) {
        setTimeout(() => {
          this.hide();
        }, this.options.hideAfter);
      }
    }
  }

  hide() {
    if (this.el) {
      this.el.classList.remove(
        'translate-y-0',
        'invisible',
        'opacity-100',
        'sm:translate-x-0',
        'visible'
      );
      this.el.classList.add(
        'invisible',
        'translate-y-2',
        'opacity-0',
        'sm:translate-y-0',
        'sm:translate-x-2'
      );
    }
  }
}

export default Notification;
